import { styled } from '@mui/material';
import { DataGridPro, gridClasses } from '@mui/x-data-grid-pro';

import { CROSSED_OUT_CLASSNAME } from './AwardingDataGrid.config';
import { AwardingDataGridRowType } from './AwardingDataGrid.types';

export const DataGridProStyled = styled(DataGridPro)(({ theme }) => ({
  [`&.${gridClasses.root}`]: {
    borderWidth: 0,
  },
  [`& .${gridClasses.row}.${AwardingDataGridRowType.QUANTITY}, & .${gridClasses.row}.${AwardingDataGridRowType.PRICE_PER_PRICE_UNIT}, & .${gridClasses.row}.${AwardingDataGridRowType.TOTAL_VALUE}`]:
    {
      '--DataGrid-rowBorderColor': 'none',
    },
  [`& .${gridClasses.row}`]: {
    [`&.${AwardingDataGridRowType.STATUS_HEADLINE}, &.${AwardingDataGridRowType.CONTRACT_HEADLINE}, &.${AwardingDataGridRowType.AWARDING_HEADLINE}`]:
      {
        [`&:hover`]: {
          backgroundColor: 'transparent',
        },
        [`& .${gridClasses.cell}`]: {
          borderRight: 'none',
        },
      },
  },
  [`& .${gridClasses.columnHeaderTitleContainerContent}`]: {
    ...theme.typography.subtitle2,
    lineHeight: 1.2,
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  [`& .${gridClasses.columnHeader}:focus-within, & .${gridClasses.cell}:focus-within`]: {
    outline: 'none',
  },
  [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.cell}:focus`]: {
    outline: 'none',
  },
  [`& .${gridClasses.cell}, & .${gridClasses.columnHeader}`]: {
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 30,
    paddingRight: 30,
    borderRight: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'}`,
  },
  // Give the first and last item cells more padding for better visual balance
  [`& .${gridClasses.row}.${AwardingDataGridRowType.LINE_ITEM} .${gridClasses.cell}`]: {
    paddingTop: 20,
  },
  [`& .${gridClasses.row}.${AwardingDataGridRowType.TOTAL_VALUE} .${gridClasses.cell}`]: {
    paddingBottom: 20,
  },
  // Quote item cells have certain states that should be visually de-emphasized
  [`& .${gridClasses.cell}.${CROSSED_OUT_CLASSNAME}`]: {
    textDecoration: 'line-through',
    color: theme.palette.text.secondary,
  },
})) as typeof DataGridPro;
